<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
    <path d="m1.565.15 14.142 14.143-1.414 1.414L.151 1.565z" /><path
      d="M14.293.15.15 14.294l1.414 1.414L15.707 1.565z"
    />
  </g>
</svg>
